import React from 'react';
import { FormattedMessage } from 'gatsby-plugin-intl';

import { ScreensWithShade } from '../../svgs/ScreensWithShade';
import { LinkButton } from '../Button';

export const Hero = () => {
  return (
    <section className="relative w-full xl:container mx-auto px-4 sm:px-6 lg:px-8 pt-32 md:pb-84 lg:py-72 z-0">
      <div className="hidden md:block relative">
        <ScreensWithShade className="absolute z-0 overflow-hidden right-0 top-64 lg:top-56" />
      </div>
      <div className="relative z-10">
        <FormattedMessage id="homepage.title">
          {(text) => (
            <h1
              className="text-2xl md:text-4xl lg:text-6xl font-heading font-bold mb-4 md:mb-6 lg:mb-0"
              dangerouslySetInnerHTML={{ __html: text }}
            />
          )}
        </FormattedMessage>
        <div className="md:hidden flex justify-center mb-6 relative">
          <svg width="320" viewBox="0 0 289 133" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect
              x="71.3103"
              y="2"
              width="77.1748"
              height="128.652"
              rx="2.94968"
              fill="white"
              stroke="#2A4365"
              strokeWidth="4"
            />
            <circle cx="109.898" cy="12.3742" r="2.96981" fill="#2A4365" />
            <path
              d="M42.9996 10.0432L43.0015 10.0432C44.0725 10.0421 45.0997 9.61659 45.8575 8.85941C46.6154 8.10218 47.042 7.07509 47.043 6.00346C47.043 5.99242 47.0474 5.98148 47.0558 5.97314C47.0641 5.96481 47.0758 5.9598 47.0883 5.95972H55.2592C56.3551 5.96117 57.4054 6.39679 58.1798 7.17053C58.9543 7.94444 59.3897 8.99339 59.3909 10.0871V126.462C59.3897 127.556 58.9543 128.605 58.1798 129.379L59.5934 130.794L58.1797 129.379C57.4051 130.153 56.3545 130.588 55.2583 130.59H6.21905C5.12283 130.588 4.07219 130.153 3.29757 129.379L1.88395 130.794L3.29756 129.379C2.52322 128.605 2.08788 127.557 2.08643 126.463V10.0862C2.08788 8.99276 2.52322 7.94421 3.29756 7.17053C4.07196 6.39679 5.1222 5.96117 6.21807 5.95972H14.3891C14.4016 5.9598 14.4132 5.96481 14.4216 5.97314C14.4299 5.98147 14.4343 5.99241 14.4343 6.00346C14.4354 7.07509 14.8619 8.10218 15.6198 8.85941C16.3776 9.61659 17.4048 10.0421 18.4758 10.0432H18.4778L42.9996 10.0432Z"
              fill="white"
              stroke="#2A4365"
              strokeWidth="4"
            />
            <rect
              x="160.405"
              y="37.6377"
              width="125.682"
              height="93.0138"
              rx="2.94968"
              fill="white"
              stroke="#2A4365"
              strokeWidth="4"
            />
            <circle cx="223.246" cy="47.5169" r="2.96981" fill="#2A4365" />
          </svg>
          <div
            className="absolute w-screen top-0 bg-gradient-to-b from-orange-200 h-128"
            style={{ zIndex: -1, top: 80 }}></div>
        </div>
        <div className="flex justify-between">
          <div className="flex-1 flex flex-col items-start">
            <FormattedMessage id="homepage.description">
              {(text) => (
                <p className="mb-4 md:mb-8 md:text-lg font-medium" dangerouslySetInnerHTML={{ __html: text }} />
              )}
            </FormattedMessage>
            <LinkButton href="/screens">Jetzt kaufen</LinkButton>
          </div>
        </div>
      </div>
    </section>
  );
};
